import LoadingButton from "@mui/lab/LoadingButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { useState } from "react";
import generateOutlineImage from "./generate-outline.png";

type Props = {
  open: boolean;
  onClose: any;
};

type CreateArticleData = {
  keyword: string;
};

export const CreateOutlineInfoDialog = (props: Props) => {
  const { open = false, onClose, ...other } = props;
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <img
        src={generateOutlineImage}
        width="200px"
        style={{ alignSelf: "center", marginTop: "25px", marginBottom: "0" }}
      />
      <DialogTitle>
        Next Step - Generate An Outline
        <DialogContentText>
          Your sources have been added! Here's the next step...
        </DialogContentText>
      </DialogTitle>
      <DialogContent>
        Customize the project settings by going to Settings in the right panel.
        Then, once you're done, click the "Generate Outline" button at the top.
      </DialogContent>
      <DialogActions>
        <LoadingButton variant="contained" onClick={props.onClose}>
          Close
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
